import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  fill: "none",
  viewBox: "0 0 10 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M4.931 5.981 1.256 9.656a.71.71 0 0 1-.525.207.71.71 0 0 1-.525-.207A.71.71 0 0 1 0 9.131q0-.318.206-.525l3.675-3.675L.206 1.256A.71.71 0 0 1 0 .731Q0 .413.206.206A.71.71 0 0 1 .731 0q.32 0 .525.206l3.675 3.675L8.606.206A.71.71 0 0 1 9.131 0q.32 0 .525.206a.71.71 0 0 1 .207.525.71.71 0 0 1-.207.525L5.981 4.931l3.675 3.675a.71.71 0 0 1 .207.525.71.71 0 0 1-.207.525.71.71 0 0 1-.525.207.71.71 0 0 1-.525-.207z"
    }, null, -1)
  ]))]))
}
export default { render: render }